import styled from "styled-components";
import { Colors } from "../../../values/colors";

const STEP_VARIANTS = {
  past: {
    bg: "rgba(45,206,159,0.1)",
    border: Colors.secondaryGreen,
    color: Colors.secondaryGreen,
    borderStyle: "solid",
  },
  active: {
    bg: "#fff",
    border: Colors.secondaryGreen,
    color: Colors.secondaryGreen,
    borderStyle: "solid",
  },
  future: {
    bg: Colors.ultraLightGray2,
    border: Colors.ultraLightGray,
    color: Colors.blueMist,
    borderStyle: "dashed",
  },
};

export const DetailBody = styled.div`
  padding: 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BackBtn = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

export const PracticedHeaderBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 1.5px ${({ $active }) => ($active ? "solid" : "dashed")}
    ${({ $active }) => ($active ? Colors.secondaryGreen : "rgba(255,255,255,0.6)")};
  background: ${({ $active }) => ($active ? Colors.secondaryGreen : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.9)")};

  &:hover {
    background: ${({ $active }) =>
      $active ? Colors.secondaryGreen : "rgba(255,255,255,0.1)"};
  }
`;

// ─── Progress Stepper ────────────────────────────────────────────────────────

export const ProgressCard = styled.div`
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StepperRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
`;

export const StepBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 8px;
  border: 1.5px ${({ $variant }) => STEP_VARIANTS[$variant]?.borderStyle || "solid"}
    ${({ $variant }) => STEP_VARIANTS[$variant]?.border || Colors.ultraLightGray};
  background: ${({ $variant }) => STEP_VARIANTS[$variant]?.bg || "#fff"};
  flex-shrink: 0;
`;

export const StepIconWrap = styled.div`
  color: ${({ $variant }) => STEP_VARIANTS[$variant]?.color || Colors.blueMist};
  display: flex;
  align-items: center;
`;

export const StepLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ $variant }) => STEP_VARIANTS[$variant]?.color || Colors.blueMist};
  white-space: nowrap;
`;

export const StepLine = styled.div`
  flex: 1;
  height: 2px;
  background: ${({ $solid }) =>
    $solid ? Colors.secondaryGreen : "transparent"};
  border-top: ${({ $solid }) =>
    $solid ? "none" : `2px dashed ${Colors.ultraLightGray}`};
  min-width: 24px;
`;

export const SuccessBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(45, 206, 159, 0.08);
  border: 1px solid rgba(45, 206, 159, 0.25);
`;

export const BannerText = styled.p`
  font-size: 13px;
  font-weight: 700;
  color: ${Colors.secondaryGreen};
  margin: 0;
  line-height: 1.3;
`;

export const BannerSubtext = styled.p`
  font-size: 12px;
  color: ${Colors.blueMist};
  margin: 0;
  line-height: 1.3;
`;

export const DesfazerBtn = styled.button`
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1.5px solid ${Colors.secondaryGreen};
  background: transparent;
  color: ${Colors.secondaryGreen};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(45, 206, 159, 0.1);
  }
`;

// ─── Plan Info Card ───────────────────────────────────────────────────────────

export const InfoCard = styled.div`
  background: #fff;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 10px;
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

export const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PriorityBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 180px;
  background: ${({ bg }) => bg};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 0px 0px 10px 10px;
  white-space: nowrap;
`;

export const InfoCardTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0;
  line-height: 1.4;
`;

export const InfoCardCategory = styled.span`
  font-size: 12px;
  color: ${Colors.blueMist};
`;

export const InfoCardDescription = styled.p`
  font-size: 13px;
  color: ${Colors.blueGray};
  margin: 0;
  line-height: 1.5;
`;

export const InfoCardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${Colors.blueMist};
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: ${({ variant }) => (variant === "danger" ? Colors.red : Colors.blueGray)};
  cursor: pointer;

  &:hover {
    background: ${Colors.ultraLightGray2};
  }
`;

// ─── Acompanhamento ───────────────────────────────────────────────────────────

export const AcompSection = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const AcompTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0;
`;

export const ProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${Colors.ultraLightGray3};
  border-radius: 6px;
  padding: 12px 16px;
`;

export const ProgressTrack = styled.div`
  flex: 1;
  height: 6px;
  border-radius: 99px;
  background: ${Colors.ultraLightGray2};
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: 99px;
  background: ${Colors.secondaryGreen};
  transition: width 0.4s ease;
`;

export const ProgressLabel = styled.span`
  font-size: 12px;
  color: ${Colors.blueMist};
  white-space: nowrap;
  flex-shrink: 0;
`;

export const TextareaBox = styled.div`
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  overflow: hidden;

  &:focus-within {
    border-color: ${Colors.primaryPurple};
  }
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px 14px;
  border: none;
  outline: none;
  resize: none;
  font-size: 13px;
  color: ${Colors.blueGray};
  font-family: inherit;
  box-sizing: border-box;
  background: transparent;

  &::placeholder {
    color: ${Colors.lightGray};
  }

  &:disabled {
    background: ${Colors.ultraLightGray2};
    cursor: not-allowed;
  }
`;

export const TextareaFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  border-top: 1px solid ${Colors.ultraLightGray2};
  background: ${Colors.ultraLightGray3};
`;

export const TextareaHint = styled.span`
  font-size: 11px;
  color: ${Colors.lightGray};
`;

export const SendBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 6px;
  background: ${Colors.secondaryGreen};
  border: none;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ActivitiesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ActivityItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: ${({ $practiced }) => ($practiced ? "rgba(45,206,159,0.04)" : "#fff")};
  border: 1px solid ${({ $practiced }) =>
    $practiced ? "rgba(45,206,159,0.15)" : Colors.ultraLightGray2};
`;

export const ActivityCheck = styled.button`
  background: none;
  border: none;
  cursor: ${({ $practiced }) => ($practiced ? "default" : "pointer")};
  padding: 0;
  margin-top: 1px;
  display: flex;
  flex-shrink: 0;
  transition: transform 0.15s;

  &:hover:not([disabled]) {
    transform: scale(1.1);
  }
`;

export const ActivityContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const ActivityText = styled.p`
  font-size: 13px;
  color: ${({ $practiced }) => ($practiced ? Colors.blueMist : Colors.blueGray)};
  margin: 0;
  line-height: 1.4;
  text-decoration: ${({ $practiced }) => ($practiced ? "line-through" : "none")};
  cursor: text;
`;

export const ActivityEditInput = styled.input`
  font-size: 13px;
  color: ${Colors.blueGray};
  line-height: 1.4;
  width: 100%;
  border: none;
  border-bottom: 1px solid ${Colors.primaryPurple};
  outline: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font-family: inherit;
`;

export const ActivityMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: ${Colors.lightGray};
`;

export const DeleteBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: ${Colors.lightGray};
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: color 0.2s;

  &:hover {
    color: ${Colors.red};
  }
`;

export const PracticedGroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  padding: 4px 0;
`;

export const PracticedGroupCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  border-radius: 99px;
  background: rgba(45, 206, 159, 0.12);
  color: ${Colors.secondaryGreen};
  font-size: 11px;
  font-weight: 700;
  padding: 0 6px;
`;
